import { Map } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'
import { keyBy } from 'utils/immutable'
import { PagedData } from 'utils/paging'
import * as actions from './actions'

const ui = handleActions({
  [actions.searchCampaigns]: (state, action) => {
    return state.set('query', action.payload.query)
  },

  [actions.setDraft]: (state, action) => {
    return state.set('draft', action.payload)
  },

  [actions.resetDraft]: (state) => {
    return state.delete('draft')
  },
}, Map())

const searchResults = handleActions({
  [actions.searchCampaignsSuccess]: (state, action) => {
    return state.merge(action.payload)
  },

  [actions.loadMoreCampaignsSuccess]: (state, action) => {
    const { data, cursor, hasMore } = action.payload
    return state.update(searchResults => searchResults
      .withMutations(result => result
        .set('cursor', cursor)
        .set('hasMore', hasMore)
        .set('status', action.type)
        .updateIn(['data'], campaigns => campaigns.concat(data))
      )
    )
  },

  [combineActions(
    actions.searchCampaigns,
    actions.searchCampaignsPending,
    actions.searchCampaignsFailed,
  )]: (state, action) => state.set('status', action.type)
}, PagedData())

const byId = handleActions({
  [actions.receiveCampaign]: (state, action) => {
    return state.set(action.payload.get('id'), action.payload)
  },

  [combineActions(
    actions.searchCampaignsSuccess,
    actions.loadMoreCampaignsSuccess,
  )]: (state, action) => {
    const { data } = action.payload

    // Keep campaigns that were already fetched
    return state.mergeWith((prev, next) => prev, keyBy(data))
  }
}, Map())

const statusById = handleActions({
  [combineActions(
    actions.fetchCampaign,
    actions.fetchCampaignPending,
    actions.fetchCampaignCancelled,
    actions.fetchCampaignFailed,
    actions.updateCampaign,
    actions.updateCampaignPending,
    actions.updateCampaignCancelled,
    actions.updateCampaignFailed,
    actions.receiveCampaign,
  )]: (state, action) => {
    const { id } = action.payload
    return state.set(id, action.type)
  }
}, Map())

export default combineReducers({ ui, searchResults, byId, statusById })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/campaigns/reducer.js